




import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

@Component
export default class HIVEButton extends Vue {
  @Prop(String) public text: string
  @Prop(String) public routeName: string
  @Prop(Boolean) public disabled: boolean

  private get getButtonRouteName() {
    return this.routeName
  }

  private get getButtonText() {
    return this.text
  }

  private get getIsButtonDisabled() {
    return this.disabled
  }
}
